<template>
  <store-log-table product-type="原料"></store-log-table>
</template>

<script>
import StoreLogTable from '@/views/modules/StoreManager/common/store-log-table'

export default {
  name: 'log',
  components: { StoreLogTable }
}
</script>

<style scoped>

</style>
